import { render, staticRenderFns } from "./AdminDocuments.vue?vue&type=template&id=9843bcdc"
import script from "./AdminDocuments.vue?vue&type=script&lang=js"
export * from "./AdminDocuments.vue?vue&type=script&lang=js"
import style0 from "./AdminDocuments.vue?vue&type=style&index=0&id=9843bcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports